export const RETURN_TO_PARAM = 'return_to'

type LocationParts = {
  pathname: string
  search?: string
  hash?: string
}

export function getLocationReturnPath(location: LocationParts): string {
  return `${location.pathname}${location.search ?? ''}${location.hash ?? ''}`
}

export function resolveReturnToPath(search: string, fallbackPath: string): string {
  const returnTo = new URLSearchParams(search).get(RETURN_TO_PARAM)
  if (!returnTo || !returnTo.startsWith('/') || returnTo.startsWith('//')) {
    return fallbackPath
  }

  return returnTo
}

export function withReturnTo(path: string, returnTo?: string | null): string {
  if (!returnTo) {
    return path
  }

  const [pathWithoutHash, hash = ''] = path.split('#')
  const [pathname, search = ''] = pathWithoutHash.split('?')
  const params = new URLSearchParams(search)
  params.set(RETURN_TO_PARAM, returnTo)

  const query = params.toString()
  const nextPath = query ? `${pathname}?${query}` : pathname
  return hash ? `${nextPath}#${hash}` : nextPath
}